module.exports = __webpack_public_path__ + "static/media/CanotisBOS.e41e93be.ico";